import { retryLazyImport } from '@/helpers/retry-lazy-import.js';
import i18n from '@/plugins/i18n.js';

const WarehouseDetails = retryLazyImport(() => import('@/modules/warehouses/WarehouseDetails.vue'));

export default [
  {
    path: '/warehouses/:warehouseId',
    name: 'warehouse.details',
    component: WarehouseDetails,
    props: true,
    meta: {
      requiresAuth: true,
      title: i18n.global.t('routes.pageTitles.warehouseDetails')
    }
  }
];
